import React, { Fragment, useState } from 'react';
import TreeView, { flattenTree } from 'react-accessible-treeview';
import ArrowRightIcon from '../../Icons/ArrowRightIcon';
import ArrowDownIcon from '../../Icons/ArrowDownIcon';
import ArrowUpIcon from '../../Icons/ArrowUpIcon';

const CategoryTree = ({ model, selectedIds, expandedIds, onNodeSelect }) => {
    const data = flattenTree(model.categoryTreeRoot);

    function Arrow({ isBranch, level, isExpanded }) {
        if (isBranch && level > 1) {
            if (!isExpanded)
                return (
                    <span style={{ marginRight: 6 }}>
                        <ArrowRightIcon />
                    </span>
                );
            else
                return (
                    <span style={{ marginRight: 6 }}>
                        <ArrowDownIcon />
                    </span>
                );
        }
        return '';
    }

    function Arrow2({ isBranch, level, isExpanded }) {
        if (isBranch && level === 1) {
            if (isExpanded) return <ArrowUpIcon />;
            else return <ArrowDownIcon />;
        }
        return '';
    }

    return (
        <Fragment>
            <div className="media-archive-category-tree-wrapper">
                <h1>Kategorier</h1>
                <div className="checkbox">
                    <TreeView
                        data={data}
                        aria-label="Checkbox tree"
                        propagateCollapse
                        onNodeSelect={onNodeSelect}
                        defaultExpandedIds={model.defaultExpandedIds}
                        expandedIds={expandedIds}
                        selectedIds={selectedIds}
                        nodeRenderer={({
                            element,
                            isBranch,
                            isExpanded,
                            isSelected,
                            getNodeProps,
                            level,
                        }) => {
                            return (
                                <div
                                    {...getNodeProps()}
                                    style={{ marginLeft: 40 * (level - 1) }}
                                    className={
                                        'item ' + (level === 1 ? 'level' : '')
                                    }
                                >
                                    <div>
                                        <Arrow
                                            isBranch={isBranch}
                                            level={level}
                                            isExpanded={isExpanded}
                                        />
                                        <span
                                            className={
                                                'item-title ' +
                                                (isSelected ? 'selected' : '')
                                            }
                                        >
                                            {element.name}
                                        </span>
                                    </div>
                                    <Arrow2
                                        isBranch={isBranch}
                                        level={level}
                                        isExpanded={isExpanded}
                                    />
                                </div>
                            );
                        }}
                    />
                </div>
            </div>
        </Fragment>
    );
};

export default CategoryTree;
